import ClassActions from "./class/class";
import axios from "axios";
import state from "./state";

const base_url = process.env.VUE_APP_WEB_URL;
const root_url = process.env.VUE_APP_ROOT_URL;
const root_url_log = process.env.VUE_APP_ROOT_URL_LOG;
const axios_url = process.env.VUE_APP_AXIOS_URL;
const im_service_url = process.env.VUE_APP_IM_SERVICE_URL;
const local = "https://localhost";

const imcasalomaaxios2 = axios.create({
  baseURL: im_service_url || `${base_url}:3008/api`,
});

const hitutoraxios = axios.create({
  baseURL: root_url,
});

const hitutoraxiosTest = axios.create({
  baseURL: axios_url ? axios_url.replace(/\/api$/, '') : `${base_url}:3000`,
});

const imCasalomaAxios = axios.create({
  baseURL: im_service_url || `${base_url}:3008/api`,
});

const action = {
  ...ClassActions,
  logout({ state, commit }, payload) {
    console.log("logout process");
  },
  async login({ state, commit, dispatch }, payload) {
    const response = await imcasalomaaxios2.post(`/user/login`, payload);
    if (response.data.error) {
      console.log("Error while Casaloma Login");
      console.log(response.data.error);
    } else {
      const { user, jwtToken } = response.data.payload;
      commit("setUser", { user, jwtToken });
      console.log("Logged In");
      console.log(response);
    }
  },
  async register({ state, commit, dispatch }, payload) {
    const response = await this.$axios.post(`/user`, payload);

    if (response.data.error) {
      console.log("Error while Casaloma Register");
      console.log(response.data.error);
    } else {
      console.log(response);
    }
  },
  // chat
  fetchClassChat({ state, commit }, payload) {
    return imcasalomaaxios2.get(`/chat/${payload}`, {
      headers: {
        Authorization: `Bearer ${state.jwtToken}`,
      },
    });
  },

  fetchHitutorMedia({ state, commit }, payload) {
    return hitutoraxios.post(`/api/NewTeachingPlatform/s`, payload, {
      headers: {
        Authorization: `Bearer ${state.HiTutorToken}`,
      },
    });
  },

  fetchHitutorMedia2({ state, commit }, payload) {
    return hitutoraxiosTest.post(`/img/${payload.ClassroomId}/${storedUrl}`, {
      headers: {
        Authorization: `Bearer ${state.HiTutorToken}`,
      },
    });
  },

  async checkInClassroom({ state, commit, dispatch }, payload) {
    return await hitutoraxios.post(
      `/api/NewTeachingPlatform/CheckInClassroom`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
  },

  async checkOutClassroom({ state, commit, dispatch }, payload) {
    return await hitutoraxios.post(
      `/api/NewTeachingPlatform/CheckOutClassroom`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${state.HiTutorToken}`,
        },
      }
    );
  },

  async chekUsername(currentUserEmail) {
    return await imCasalomaAxios.get(`/user/` + currentUserEmail, {
      headers: {
        Authorization: `Bearer ${state.jwtToken}`,
      },
    });
  },

  updateValue(newValue) {
    return (state.valueToChange = newValue);
  },
};

export default action;
